import { render, staticRenderFns } from "./IdeaItem.vue?vue&type=template&id=09c5ae50&"
import script from "./IdeaItem.vue?vue&type=script&lang=js&"
export * from "./IdeaItem.vue?vue&type=script&lang=js&"
import style0 from "./IdeaItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports